<template><div><h1>vux 使用 nuxt 实现服务端渲染</h1>
<p>请直接参考源码目录 <a href="https://github.com/airyland/vux/tree/v2/ssr/nuxt">/ssr/nuxt</a></p>
</div></template><script>
export default {
  head: {"title":"vux 使用 nuxt 实现服务端渲染 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vux-nuxt-ssr-293.vue?51f63c41